/*
 * @Author: lidan
 * @Date: 2020-12-15 09:06:33
 * @LastEditTime: 2020-12-16 13:37:13
 * @LastEditors: lidan
 * @Description: 送货员津贴明细表api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\deliveryAllowanceDetails.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取送货员津贴明细表格数据
export function queryPageDetailDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/deliveryReport/queryPageDetail`,
    method: "post",
    data
  });
}

// 调整费用接口
export function changeFeeDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/deliveryReport/changeFee`,
    method: "post",
    data
  });
}

// 调整记录查询接口
export function getHistoryDelivery(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/deliveryReport/getHistory`,
    method: "get",
    params
  });
}

// 导出送货员津贴明细表
export function detailExportDelivery(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/deliveryReport/detailExport`,
    method: "post",
    data
  });
}
